<ng-container *ngFor="let group of groups || []">
  <app-select-option *ngIf="!(group.isHidden$ | async)"
                     class="group"
                     iconSelected="keyboard_arrow_right"
                     [selected]="group.isSelected$ | async"
                     (click)="onClick.emit(group)">
    <ng-container *ngTemplateOutlet="template; context: {$implicit: group}"></ng-container>
  </app-select-option>
</ng-container>
